<template>
  <div>
    <md-field>
      <label>{{ config.label }}</label>
      <ul class="search-modal-selections _flatTags">
        <li v-if="config.pageMode == 'new'">Record must be created first</li>
        <li v-else-if="config.pageMode !== 'edit' && (!value || !value.length)">No {{ config.label }} selected</li>
        <li v-else v-for="_item in value" :key="_item.id">
          <a v-if="config.pageMode == 'view' || config.pageMode == 'assignee'" :href="'#/' + config.list.editPath + '/' + _item.id">
            <template v-if="config.list.targetName">
              <span>{{ _item[config.list.targetName] }}&nbsp;</span>
            </template>
            <template v-else>{{ _item.name }}</template>
          </a>
          <template v-else>
            <template v-if="config.list.targetName">
              <span>{{ _item[config.list.targetName] }}&nbsp;</span>
            </template>
            <template v-else>{{ _item.name }}</template>
          </template>
          <md-button v-if="config.pageMode == 'edit'" class="md-button-tiny md-just-icon md-danger md-simple" @click.stop.native="confirmRemove(_item)">
            <md-icon>close</md-icon>
          </md-button>
        </li>
        <li v-if="allowAdd">
          <md-button @click="openSearchModal" class="openSearchModal-button md-button md-just-icon md-simple md-button-tiny">
            <md-icon>add</md-icon>
          </md-button>
        </li>
      </ul>
    </md-field>

    <md-dialog-confirm
      :md-active.sync="confirmDialog.show"
      :md-title="confirmDialog.title"
      :md-content="confirmDialog.content"
      md-confirm-text="Yes"
      md-cancel-text="Cancel"
      @md-cancel="resetDialog"
      @md-confirm="remove"
      class="_flatConfirm"
    />

    <md-dialog :md-active.sync="showSearchModal">
      <md-dialog-title>Search for {{ config.label }}</md-dialog-title>
      <md-dialog-content>
        <ElasticList
          class="_flatList"
          :list.sync="config.list"
          :exclude="existingRecordsFilter"
          :filter="config.filter"
          :relateRecordInput="newRecordInput"
          :relateRecordInputField="config.list.relateRecordInputField"
          @reportPortfolioAdded="onReportPortfolioAdded"
        ></ElasticList>
      </md-dialog-content>
      <md-dialog-actions class="_flatListActions">
        <md-button class="md-theme-default" @click="closeSearchModal">Close</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import ElasticList from "@/components/DynamicForm/ElasticList";
import { API, Auth, graphqlOperation } from "aws-amplify";
import * as mutations from "@/graphql/mutations";
import * as queries from "@/graphql/queries";
import * as subscriptions from "@/graphql/subscriptions";
import aws_exports from "@/aws-exports";
import gql from "graphql-tag";

export default {
  name: "report-search-modal",
  components: {
    ElasticList,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    config: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showSearchModal: false,
      confirmDialog: {
        show: false,
        content: "",
        title: "",
      },
      subscriptions: {},
      deleteQueue: {},
    };
  },
  apollo: {
    subscriptions: {
      query: function() {
        return gql(queries['searchUsers']);
      },
      variables: {
        filter: { id: { eq: '-1' } },
        limit: 1,
      },
      update: () => [],
    }
  },
  watch: {
    'value': {
      immediate: true,
      handler: function(){
        if(this.config.limit && this.value.length >= this.config.limit)
          this.closeSearchModal();
      }
    }
  },
  computed: {
    allowAdd: function () {
      return (this.config.limit) ? (this.config.pageMode == 'edit' && this.value.length < this.config.limit) ? true : false : true;
    },
    existingRecordsFilter: function() {
      let result = null;
      
      if (!this.value || !this.value.length || !this.config ||  !this.config.list) {
        return result;
      }
      
      const filters = [];
      const idField = this.config.list.idField ? this.config.list.idField : "id";
      
      this.value.forEach(_item => {
        const matchObj = {};
        matchObj[idField] = _item.id;
        filters.push({ match: matchObj });
      });
      
      if (filters.length) {
        result = { must_not: filters };
      }
      
      console.log("existingRecordsFilter result", result);
      return result;
    },
    newRecordInput: function() {
      let input = this.config.list.relateRecordInput;
      // let routeField = this.config.list.relateRecordRouteField;
      // input[routeField] = this.$route.params.id;
      return input;
    },
  },
  methods: {
    openSearchModal() {
      this.showSearchModal = true;
    },
    closeSearchModal() {
      this.showSearchModal = false;
      //list.needsRefresh = true;
    },
    resetDialog() {
      this.confirmDialog.title = "";
      this.confirmDialog.content = "";
      this.confirmDialog.item = false;
    },
    async remove() {
      await this.delete(this.confirmDialog.item);
      this.resetDialog();
    },
    confirmRemove(item) {
      this.confirmDialog.show = true;
      this.confirmDialog.item = item;

      //build the name first
      let list = this.config.list;

      let nameFields = list.deleteMessageNameFields ? list.deleteMessageNameFields : ["name"];
      let objectName = "";
      nameFields.forEach((nf, index) => {
        objectName += item[nf];
        if (index !== nameFields.length - 1) objectName += " ";
      });

      // without at least 1 character this will use the default on the right
      let title = list.deleteMessageTitle ? list.deleteMessageTitle : "Are you sure you want to remove {objectName}?";
      this.confirmDialog.title = title.replace("{objectName}", objectName);

      //this test is different because we want to allow config of '' to omit the default text
      this.confirmDialog.content = typeof list.deleteMessageText !== "undefined" ? list.deleteMessageText : `The change cannot be undone.`;
    },
    async delete(item) {
      if (!this.value || !this.value.length) {
        return;
      }
      const index = this.value.findIndex(_item => _item.id == item.id);
      if (-1 != index) {
        this.value.splice(index, 1);
      }
    },
    onReportPortfolioAdded(item) {
      let value = [];
      if (this.value && this.value.length) {
        value = this.value;
      }
      const index = value.findIndex(_item => _item.id == item.id);
      if (-1 == index) {
        value.push(item);
        this.$emit('input', value);
      }
    }
  },
  async mounted() {
    /* [i] Run any subscriptions configured for the list (relateList in this scenario) */
    let context = this;
    let list = this.config.list;
    if (list && list.subscriptions) {
      this.$loopo(list.subscriptions, (sub, name) => {
        this.$c.log("SUBSCRIPTION CONFIGURED: " + name);
        if (typeof subscriptions[name] === "undefined") {
          this.$c.error("SUBSCRIPTION [" + name + "] not found!");
          return;
        }
        let thisFunc = list.subscriptions[name].function;
        this.$apollo.queries.subscriptions.subscribeToMore({
          document: gql(subscriptions[name]),
          updateQuery: (previousResult, { subscriptionData }) => {
            console.log('SUBSCRIPTION ', name, subscriptionData);
            thisFunc({ value: subscriptionData });
          },
        });
      });
    }

    if (this.config.subscribe) {
      let subscription;

      /* [i] Subscribe to the model that corresponds to the form input for onCreate */
      subscription = this.config.subscribe.onCreate;

      if (subscription) {
        let subscriptionName = "onCreate" + subscription.model;
        this.subscriptions[subscriptionName] = {
          /** We will save the subscription to result so we can destroy it later */
          result: null,
          function: (eventData) => {
            this.$c.log("SUBSCRIPTION Trigger: " + subscriptionName);
            let eventRecord = eventData.value.data[subscriptionName];
            if (eventRecord) {
              if (context.value && context.value.length) {
                const index = context.value.findIndex(_item => _item.id == eventRecord.id);
                if (-1 == index) {
                  const newValue = [].concat([], context.value, [eventRecord]);
                  context.$emit('input', newValue);
                }
              }
            }
          },
        };
      }

      /* [i] Subscribe to the model that corresponds to the form input for onCreate */
      subscription = this.config.subscribe.onDelete;
      if (subscription) {
        let subscriptionName = "onDelete" + subscription.model;
        this.subscriptions[subscriptionName] = {
          result: null,
          function: (eventData) => {
            this.$c.log("SUBSCRIPTION Trigger: " + subscriptionName);
            let eventRecord = eventData.value.data[subscriptionName];

            if (!this.deleteQueue[eventRecord.id]) {
              // [i] "Lock" this eventRecord from being removed more than 1 time
              this.deleteQueue[eventRecord.id] = true;

              let form = this.form;
              let recordData = this.recordData;
              form[subscription.inputField].forEach((item, index) => {
                if (item.relateRecordId === eventRecord.id) {
                  // [i] Update the form array
                  form[subscription.inputField].splice(index, 1);
                  // [i] Update the recordData array (this is used for filtering the list used in here)
                  recordData[subscription.inputField].items.forEach((rdItem, rdIndex) => {
                    if (rdItem.id === eventRecord.id) {
                      recordData[subscription.inputField].items.splice(rdIndex, 1);
                    }
                  });
                }
              });

              // [i] Release function "lock"
              delete this.deleteQueue[eventRecord.id];
            }
          },
        };
      }

      this.$loopo(this.subscriptions, (sub, name) => {
        this.$c.log("SUBSCRIPTION CONFIGURED: " + name);
        if (typeof subscriptions[name] === "undefined") {
          this.$c.error("SUBSCRIPTION [" + name + "] not found!");
          return;
        }
        let thisFunc = this.subscriptions[name].function;
        this.$apollo.queries.subscriptions.subscribeToMore({
          document: gql(subscriptions[name]),
          updateQuery: (previousResult, { subscriptionData }) => {
            console.log('SUBSCRIPTION ', name, subscriptionData);
            thisFunc({ value: subscriptionData });
          },
        });
      });
    }
  },
};
</script>

<style lang="scss">
._flatList {
  position: relative;
}
._flatListActions,
._flatConfirm .md-dialog-actions {
  padding: 24px;
  padding-top: 0;
}
.md-dialog._flatConfirm {
  width: auto;
}
._flatTags {
  display: flex;
  flex-wrap: wrap;
  li {
    margin: 0 5px 5px 0;
    padding: 2px 10px;
    background-color: #eee;
    border-radius: 2px;
  }
}
</style>
